module.exports = __webpack_public_path__ + "img/amex.d6f58693.svg";